import React, { useState } from 'react';
import { Flex, Text } from '@cko/primitives';
import styled, { css } from 'styled-components';
import { baseSidebarElement } from './baseSidebarElement';
import { Accordion } from './Accordion';
const StyledHeader = styled.span `
  ${baseSidebarElement}

  display: inline-flex;
  align-items: center;
  height: 24px;
  margin: var(--layout-sandgrain);
  padding: var(--layout-sandgrain);
  line-height: 24px;

  ${({ selected }) => selected &&
    css `
      .iconSelected {
        display: initial;
      }
      .iconDefault {
        display: none;
      }
    `}
`;
const TopLink = styled(Text) `
  font: ${({ isActivePath }) => (isActivePath ? 'var(--body-xs-emphasis)' : 'var(--body-xs)')};
`;
// @deprecated Sidebar has been removed and Sidebar links will follow soon. See https://checkout.atlassian.net/browse/DASH-2788
export const LinkAccordion = ({ children, id, isActivePath, icons, headerText }) => {
    const [isAccordionOpen, showHideAccordionContent] = useState(false);
    const IconDefault = icons.default;
    const IconSelected = icons.selected;
    return (React.createElement(Accordion, { id: id, title: React.createElement(StyledHeader, { selected: isActivePath },
            React.createElement("span", { className: "icon iconDefault" },
                React.createElement(IconDefault, null)),
            React.createElement("span", { className: "icon iconSelected" },
                React.createElement(IconSelected, null)),
            React.createElement(TopLink, { isActivePath: isActivePath }, headerText)), isOpen: isAccordionOpen || isActivePath, onClick: () => showHideAccordionContent((prev) => !prev), showIcon: false },
        React.createElement(Flex, { flexDirection: "column" }, children)));
};
